module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/last-3c426ab82e04fcbb48ed7c0872862d5a.jpg";